import { render, staticRenderFns } from "./JobLogsList.vue?vue&type=template&id=63700e7f"
import script from "./JobLogsList.vue?vue&type=script&lang=ts"
export * from "./JobLogsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports